import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSah: CultureInfo = {
  name: 'sah',
  displayName: 'Sakha',
  iso3LanguageCode: 'sah',
  iso2LanguageCode: 'sah',
  ietfLanguageTag: 'sah',
  parent: null
};
